module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAgICAgJCAkKCgkNDgwODRMREBARExwUFhQWFBwrGx8bGx8bKyYuJSMlLiZENS8vNUROQj5CTl9VVV93cXecnNEBCAgICAkICQoKCQ0ODA4NExEQEBETHBQWFBYUHCsbHxsbHxsrJi4lIyUuJkQ1Ly81RE5CPkJOX1VVX3dxd5yc0f/CABEIABkAGQMBIgACEQEDEQH/xAAYAAADAQEAAAAAAAAAAAAAAAAAAQIDBP/aAAgBAQAAAADsuq57p5WA1n//xAAVAQEBAAAAAAAAAAAAAAAAAAABBf/aAAgBAhAAAACaj//EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oACAEDEAAAAEr/xAAdEAACAQQDAAAAAAAAAAAAAAAAARACESIxYWKB/9oACAEBAAE/AHCPXCEZdhLbFF+SnTEOP//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8AH//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQMBAT8AH//Z"


//////////////////
// WEBPACK FOOTER
// ./src/assets/color/sage_green_sw.jpg
// module id = Ve3n
// module chunks = 14